import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session"; // Use sessionStorage for persistence
import authReducer from "../features/auth/authSlice";
import administrationReducer from "../features/auth/AdministrationSlice";
import userDetailsReducer from "../features/auth/userDetailSlice";
import uiControlReducer from "../features/auth/uiControlSlice";
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"; // Import persist actions

// Combine all reducers into a single root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  administration: administrationReducer,
  user: userDetailsReducer,
  ui: uiControlReducer,
});

// Persist configuration
const persistConfig = {
  key: "root",
  storage: storageSession, // Use sessionStorage for persistence
  whitelist: ["auth", "administration", "user", "ui"], // Specify which reducers to persist
};

// Apply persistReducer to the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], // Allow persist actions
      },
    }),
});

// Create the persistor
export const persistor = persistStore(store);

// Export types for state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
